export const GET_SALES_DATA_BY_DATE = "GET_SALES_DATA_BY_DATE";
export const GET_SALES_DATA_BY_DATE_RANGE = "GET_SALES_DATA_BY_DATE_RANGE";
export const GET_PAYMENT_METHOD_WISE_BILL_COUNT = "GET_PAYMENT_METHOD_WISE_BILL_COUNT";
export const GET_SALES_DATA_AGAINST_DATE = "GET_SALES_DATA_AGAINST_DATE";
export const GET_PAYMENT_METHOD_WISE_BILL_COUNT_RANGE = "GET_PAYMENT_METHOD_WISE_BILL_COUNT_RANGE";
export const SET_RANGE_STATE_CHANGE_LOADING = "SET_RANGE_STATE_CHANGE_LOADING";
export const SET_TODAY_STATE_CHANGE_LOADING = "SET_TODAY_STATE_CHANGE_LOADING";
